
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import eventBus from '@/utils/eventBus';
import { checkPermissionCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import { addGroupPush, editGroupPush, delGroupPush, groupPushList } from '@/api/group';

import GroupSearch from './components/GroupSearch.vue';
import DialogScheduling from '@/components/DialogScheduling/index.vue';
import GroupStep2 from './components/GroupStep2.vue';

@Component({
  name: 'GroupsPushCustomer',
  components: {
    GroupSearch,
    DialogScheduling,
    GroupStep2

    // GroupCustomer,DialogGroupStep2,// DialogDept,
  }
})
export default class extends Vue {
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private groupPushType: any = {
    type: 1,
  }

  private searchParams: any = {}
  private tableData:any = [];
  private listLoading = false;
  private editData:any = {};

  // private selcetCustomer:any=[]
  // private dialogSelectedVisible=false
  // private selectedDeptvisible = false;
  private selectedDept:any={}
  private isCustomer=false
  private activeNmuber = 0
  private radioWay = 1
  private dialogGroupStepVisible = false

  // 分派处理  - 部门
  private searchDept: any = {
    name: ''
  }
  private deptLoading = false;
  private page:number=1;
  private pageCount:number=1;
  private deptTableData: any = []
  private selectedData:any = {}
  // 获取 工程师
  private engPage:number=1
  private engPageCount:number=1;
  private engTableData: any = []
  private selectedUserData:any={}

  created() {
    this.isCustomer = checkPermissionCompany(UserModule.getCompanyId, Type.CUSTOMER_COMPANY);

    let that = this;
    eventBus.$on('groupSearch', (val: any) => {
      that.searchParams = val;
      that.getList();
    });

    this.$once('hook:beforeDestroy', () => {
      eventBus.$off('groupSearch');
    });

    that.getList();
  }

  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }

  private getList() {
    this.listLoading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      group_type: 0,
      customer_name: this.searchParams.customer,
      servicer_dept_name: this.searchParams.dept,
      engineer_user_name: this.searchParams.engineer,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    groupPushList(params)
      .then((res: any) => {
        if (res.data) {
          this.pagination.total = res.data.count;
          this.tableData = res.data.list;
          for (let index = 0; index < this.tableData.length; index++) {
            if (this.tableData[index].group_push) {
              let cL:any = this.tableData[index].group_push.customer_list;
              this.tableData[index].group_push.customerList = cL && cL.length > 0 ? cL.slice(1) : [];
            }
          }
        } else {
          this.pagination.total = 0
          this.tableData = [];
        }

        this.listLoading = false;
      })
      .catch((err: any) => {
        this.tableData = [];
        this.pagination.total = 0
        this.listLoading = false;
        let msg = err.msg;
      });
  }

  // 分派部门 列表
  // private getDeptList() {
  //   this.deptLoading = true;
  //   let params: any = {
  //     page: this.page,
  //     user_id: UserModule.getUserId,
  //     user_name: UserModule.getUserName,
  //     company_id: UserModule.getCompanyId,
  //     type: '9', // 部门类型 1报修部门 2服务部门 3审批部门 9所有部门 (必填)
  //     dept_type: 2 // 部门类型 1报修部门 2服务部门
  //   };
  //   if (this.searchDept.name) {
  //     params.name = this.searchDept.name;
  //   }
  //   getDepartmentList(params)
  //     .then((res) => {
  //       if (res.data) {
  //         this.pageCount = res.data.page_count;
  //       }
  //       if (this.page === 1) {
  //         this.deptTableData = res.data.list;
  //       } else {
  //         this.deptTableData = this.deptTableData.concat(res.data.list);
  //       }
  //       this.setDept(this.deptTableData);
  //       this.deptLoading = false;
  //     })
  //     .catch((err) => {
  //       this.deptLoading = false;
  //       let msg = err.msg;
  //     });
  // }
  // private setDept(list:any) {
  //   if (this.selectedDept && this.selectedDept.servicer_dept_id) {
  //     if (list && list.length > 0) {
  //       for (let item of list) {
  //         if (this.selectedDept.servicer_dept_id === item.dept_id) {
  //           this.selectedData = item;
  //           this.getWorkUser();
  //           return;
  //         }
  //       }
  //     }
  //   }
  // }
  // private selectedDeptChange(val: any) {
  //   this.engPage = 1;
  //   this.selectedUserData = {};
  //   if (this.radioWay === 2) {
  //     this.getWorkUser();
  //   }
  // }
  // private getWorkUser() {
  //   const params: any = {
  //     dept_id: this.selectedData.dept_id,
  //     user_id: UserModule.getUserId,
  //     user_name: UserModule.getUserName,
  //     company_id: UserModule.getCompanyId,
  //     page: this.engPage,
  //     size: 10
  //   };

  //   getWorkUser(params)
  //     .then((res: any) => {
  //       if (res.data) {
  //         if (this.engPage === 1) {
  //           this.engTableData = res.data.list;
  //         } else {
  //           this.engTableData = this.engTableData.concat(res.data.list);
  //         }
  //         this.setSelectEng(this.engTableData);
  //         this.engPageCount = res.data.page_count;
  //       } else {
  //         if (this.engPage === 1) {
  //           this.engTableData = [];
  //         }
  //       }
  //     })
  //     .catch((err: any) => {
  //       if (this.engPage === 1) {
  //         this.engTableData = [];
  //       }
  //       let msg = err.msg;
  //     });
  // }
  // private setSelectEng(list:any) {
  //   if (this.selectedDept && this.selectedDept.engineer_user_id) {
  //     if (list && list.length > 0) {
  //       for (let item of list) {
  //         if (item.user && (this.selectedDept.engineer_user_id === item.user.user_id)) {
  //           this.selectedUserData = item;
  //         }
  //       }
  //     }
  //   }
  // }
  // private selectedEngChange(val: any) {
  //   if (this.selectedUserData === val) {
  //     this.selectedUserData = {};
  //   } else {
  //     this.selectedUserData = val;
  //   }
  // }

  private isDef=false;
  private pushNameData: any = {
    pushName: ''
  }
  private pushId=''

  private addOperationhandle() {
    this.editData = {};
    this.isDef = false;
    this.dialogGroupStepVisible = true
    // this.selectedDept = {};
    // this.selcetCustomer = [];
    // this.deptSelected = {};
    // this.pushNameData.pushName = '';
    // this.pushId = '';
  }
  // private prevStep() {
  //   if (this.activeNmuber === 2) {
  //     this.activeNmuber = 1
  //   } else {
  //     this.activeNmuber = 0
  //   }
  // }
  // private confirmData() {
  // let data:any = {};
  // data.group_name = this.pushNameData.pushName;// 群组名
  // data.selcetCustomer = this.selcetCustomer;// 客户
  // data.servicer_dept_id = this.selectedData.dept_id; // 部门
  // data.servicer_dept_name = this.selectedData.name;
  // if (this.selectedUserData.user) {
  //   data.engineer_user_id = this.selectedUserData.user.user_id;
  //   data.engineer_user_name = this.selectedUserData.user.name;
  // }
  // this.$emit('selectedStepNext', data);
  // this.close()
  // }

  // 新建默认群组
  private addDefOperationhandle() {
    this.isDef = true;
    this.pushId = '';
    this.dialogGroupStepVisible = true

    // this.selcetCustomer = [];
    // this.selectedDept = {};
    // this.deptSelected = {};
    // this.pushNameData.pushName = '';
    // this.$prompt('名称', '群组名称', {
    //   confirmButtonText: '下一步',
    //   cancelButtonText: '取消',
    //   inputErrorMessage: '请输入1-30位的名称',
    //   inputPlaceholder: '请输入群组名称(不超过30字)',
    //   inputPattern: /^\S.{1,29}$/,
    //   inputValue: this.pushNameData.pushName
    // }).then(({ value }: any) => {
    //   this.pushNameData.pushName = value;
    //   this.selectedDeptvisible = true;
    // }).catch(() => {
    // });
  }
  // private checkedCustomerChange(val:any) {
  //   this.selcetCustomer = val;
  // }

  private operationCustomerHandle() { // 客户管理，跳转链接
    this.$router.push({
      path: '/Customer/list',
      query: { }
    });
  }
  private operationhandle(val: any) { // 编辑
    this.editData = val;
    if (parseInt(val.is_default_group) === 1) {
      this.isDef = true;
    } else {
      this.isDef = false;
    }
    this.dialogGroupStepVisible = true

    // this.pushId = val.id;
    // if (val.group_push) {
    //   if (parseInt(val.sub_type) === 1) { // 推单至排班
    //     this.deptSelected.dept_id = val.group_push.servicer_dept_id;
    //     this.deptSelected.name = val.group_push.servicer_dept_name;
    //   } else {
    //     this.selectedDept = val.group_push;
    //   }
    // }
    // this.pushNameData.pushName = this.editData.group_name;
    // this.$prompt('名称', '群组名称', {
    //   confirmButtonText: '下一步',
    //   cancelButtonText: '取消',
    //   inputErrorMessage: '请输入1-30位的名称',
    //   inputPlaceholder: '请输入群组名称(不超过30字)',
    //   inputPattern: /^\S.{1,29}$/,
    //   inputValue: this.pushNameData.pushName
    // }).then(({ value }: any) => {
    //   this.pushNameData.pushName = value;
    //   if (parseInt(val.is_default_group) === 1) {
    //     this.isDef = true;
    //     this.selectedDeptvisible = true;
    //   } else {
    //     this.isDef = false;
    //     this.selcetCustomer = this.editData.group_push.customer_list;
    //     this.dialogSelectedVisible = true;
    //   }
    // }).catch(() => {
    // });
  }

  // private nextHandle(val:number) {
  //   if (!this.selcetCustomer || this.selcetCustomer.length < 1) {
  //     this.showErrorMsg('请选择客户');
  //     return;
  //   }
  //   if (val === 1) {
  //     this.selectedDeptvisible = true;
  //   } else {
  //     // 排班
  //     this.departmentVisible = true;
  //   }
  // }
  private deleteAuthGroup(val:any) {
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          id: val.id
        };
        delGroupPush(params)
          .then((res) => {
            this.showSuccessMsg('删除成功');
            this.getList();
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {});
  }
  // private closeGroupTwoVisible(val: any) {
  //   this.selectedDeptvisible = val;
  // }
  // private selectedStepNext(val: any) {
  //   this.selectedDept = val;
  //   this.add(val.group_name, this.isDef, val.sub_type);
  // }
  // private add(name: any, isDefault:boolean, subType:number) {
  //   let params:any = {
  //     user_id: UserModule.getUserId,
  //     company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
  //     servicer_company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
  //     servicer_company_name: UserModule.getCompanyName,
  //     group_type: 0,
  //     sub_type: subType
  //   };
  //   if (this.selectedDept.selcetCustomer) { // 选择客户
  //     if (this.selectedDept.selcetCustomer && this.selectedDept.selcetCustomer.length > 0) {
  //       params.customer_list = JSON.stringify(this.selectedDept.selcetCustomer);
  //     }

  //     if (this.selectedDept.servicer_dept_id) {
  //       params.servicer_dept_id = this.selectedDept.servicer_dept_id;
  //       params.servicer_dept_name = this.selectedDept.servicer_dept_name;
  //     }
  //     if (this.selectedDept.engineer_user_id) {
  //       params.engineer_user_id = this.selectedDept.engineer_user_id;
  //       params.engineer_user_name = this.selectedDept.engineer_user_name;
  //     }
  //   }
  //   params.group_name = name;
  //   params.is_default_group = isDefault ? '1' : '0';
  //   if (this.pushId) {
  //     params.id = this.pushId;
  //     editGroupPush(params).then(res => {
  //       if (subType === 1) {
  //         this.dialogSchedulingVisible = true;
  //         this.groupData = {
  //           group_push_id: this.pushId,
  //           group_push_name: this.pushNameData.pushName
  //         };
  //       } else {
  //         this.showSuccessMsg((res as any).msg);
  //         this.dialogSelectedVisible = false;
  //         this.selectedDeptvisible = false;
  //         this.getList();
  //       }
  //     }).catch(err => {
  //       this.showErrorMsg(err.msg);
  //     });
  //   } else {
  //     addGroupPush(params).then(res => {
  //       if (subType === 1) {
  //         if (res.data && res.data.group_cs) {
  //           this.pushId = res.data.group_cs.id;
  //         }
  //         this.dialogSchedulingVisible = true;
  //         this.groupData = {
  //           group_push_id: this.pushId,
  //           group_push_name: this.pushNameData.pushName
  //         };
  //       } else {
  //         this.showSuccessMsg((res as any).msg);
  //         this.dialogSelectedVisible = false;
  //         this.selectedDeptvisible = false;
  //         this.getList();
  //       }
  //     }).catch(err => {
  //       this.showErrorMsg(err.msg);
  //     });
  //   }
  // }
  private closeGroupStepVisible(val: any) {
    this.dialogGroupStepVisible = val
  }

  // 排班
  // private departmentVisible=false;
  // private deptType=2
  private deptSelected:any={};
  private dialogResultSchedulingHandle:any={}

  // private departmentDialogClose(val:any) {
  //   this.departmentVisible = val;
  // }
  // private departmentSelected(val:any) {
  //   this.deptSelected = val;
  //   this.selectedDept.servicer_dept_id = val.dept_id;
  //   this.selectedDept.servicer_dept_name = val.name;
  // this.add(this.pushNameData.pushName, this.isDef, 1);
  // }

  // 设置排班
  private setSchedulinghandle(val:any) {
    this.editData = val;
    this.pushId = val.id;
    this.isDef = parseInt(val.is_default_group) === 1;
    this.pushNameData.pushName = val.group_name;
    if (val.group_push) {
      if (parseInt(val.sub_type) === 1) {
        this.deptSelected.dept_id = val.group_push.servicer_dept_id;
        this.deptSelected.name = val.group_push.servicer_dept_name;
      } else {
        this.selectedDept = val.group_push;
      }
    }
    this.groupData = {
      group_push_id: this.pushId,
      group_push_name: this.pushNameData.pushName
    };
    this.dialogSchedulingVisible = true;
  }
  // 排班 弹窗
  private dialogSchedulingVisible=false
  private groupData:any={}

  private dialogSchedulingConfirm(val:any) {
    this.dialogSchedulingVisible = false;
    // this.departmentVisible = false;
    // this.dialogSelectedVisible = false;
    this.getList();
  }

  private dialogSchedulingClose(val:boolean) {
    this.dialogSchedulingVisible = val;
  }

  private selectedGroupData() {
    this.getList();
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
